module.exports = __webpack_public_path__ + "static/img/search.a9463ff0.png";